import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, hasOne, references } from '@apexdesigner/schema-tools';

export const studentAssignment = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    from: z.string().nullable().optional().presentAs('date').describe('From'),

    to: z.string().nullable().optional().presentAs('date').describe('To'),

    status: z.string().nullable().optional().describe('Status'),

    selectedStudentId: z
      .number()
      .hidden()
      .describe('Foreign key to SelectedStudent'),

    slotId: z
      .number()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to Slot'),

    termTutorId: z
      .number()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to TermTutor'),

    replacesId: z
      .number()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to StudentAssignment'),

    selectedStudent: belongsTo('SelectedStudent'),

    slot: references('Slot'),

    termTutor: references('TermTutor'),

    replaces: references('StudentAssignment'),

    replacedBy: hasOne('StudentAssignment', 'replacesId'),
  })
  .describe(
    'Pairs a selected student with a slot and term tutor, supporting propose/replace workflows.',
  )
  .as('StudentAssignment');

export { studentAssignment as studentAssignmentSchema };
